export default function emailValidator(input) {
    const parsed = {
        isValid: false,
        formattedValue: null,
        errorText: null
    };
    const errors = {
        invalidChar: 'ZIP Code should be only numbers',
        invalidLength: 'ZIP Code must have 5 or 9 digits'
    };

    let cleanedValue = '';
    const zipCode5Pattern = /^\d{5}$/;
    const zipCode9Pattern = /^(\d{5})-?(\d{4})$/;
    const numberPattern = /[0-9]/;
    const allowedPattern = /[\W\d]/;

    if (zipCode5Pattern.test(input) || zipCode9Pattern.test(input)) {
        // It's perfect
        parsed.isValid = true;
        parsed.formattedValue = input

        return parsed
    }


    // Else it's not perfect, so we check for invalid characters
    if (typeof input === 'string' && input.length) {
        for (let i = 0; i < input.length; i += 1) {
            if (numberPattern.test(input[i])) {
                cleanedValue += input[i];
            }
            else if (!allowedPattern.test(input[i])) {
                parsed.errorText = errors.invalidChar;
                return parsed;
            }
        }
    }

    if (cleanedValue.length !== 5 && cleanedValue.length !== 9) {
        // ZIP Code is incorrect length
        parsed.errorText = errors.invalidLength;
        return parsed;
    }

    // ZIP Code is correct format
    parsed.isValid = true;
    parsed.formattedValue = cleanedValue.length === 9
        ? cleanedValue.replace(zipCode9Pattern, '$1-$2')
        : cleanedValue

    return parsed;
}
